import { gql } from '@apollo/client'

export const GET_PROFORMAS_QUERY = gql`
  query Proformas($filter: ProformaFilter!) {
    proformas(filter: $filter) {
      proformaID
      status
      proformaNumber
      createdAt
      updatedAt
    }
  }
`

export const PROFORMA_QUERY = gql`
  query Proforma($proformaID: ID!) {
    proforma(proformaID: $proformaID) {
      proformaID
      status
      expiresAt
      paymentDeadline
      createdAt
      updatedAt
      transactions {
        transactionID
        walletID
        type
        status
        amount
        amount
        time
        description
        relatedTransactionIDs
        userID
        createdAt
        updatedAt
        creditorID
        correlationID
        serviceID
        requestTime
        paymentStatus
        dueDate
        paymentTermID
        proformaID
        usedBalanceType
        sumOfPenalty
        rewardOfEarlyPayment
        reservationNumber
        creditorEntity {
          entityType
          entityID
          entityCode
          displayEntityCode
          entityName
        }
        currency
      }
      attachments {
        url
        size
        name
        id
      }
      proformaNumber
      description
      histories {
        proformaHistoryID
        status
        createdAt
      }
    }
  }
`
